// extracted by mini-css-extract-plugin
var _1 = "MenuItem-moduleMenuItem__Wyubu";
var _2 = "MenuItem-moduleactive__Td446";
var _3 = "MenuItem-moduleblocked__RFeFP";
var _4 = "MenuItem-modulecounter__x_rSQ";
var _5 = "MenuItem-moduleicon__V5KXv IconNG-moduleiconContainer__SxWZ0";
var _6 = "MenuItem-moduletext__Ewt8f";
var _7 = "MenuItem-moduletooltip__spqRq";
var _8 = "MenuItem-moduletooltipText__bBHMf";
export { _1 as "MenuItem", _2 as "active", _3 as "blocked", _4 as "counter", _5 as "icon", _6 as "text", _7 as "tooltip", _8 as "tooltipText" }
